import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {IStockChangeCondition, StockChangeCondition} from 'app/blocks/model/stock-change-condition.model';

@Injectable({
    providedIn: 'root'
})
export class StockChangeConditionService extends EntityCrudService<IStockChangeCondition> {
    constructor(http: HttpClient) {
        super(http, Resource.STOCK_CHANGE_CONDITION, (obj?) => new StockChangeCondition(obj));
    }
}
